import { render } from "./ChevronRightIcon.vue?vue&type=template&id=4bc2ecfc"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__